import {
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Typography,
  Link,
} from "@mui/material";
import React from "react";
import { Control, Controller, FieldErrors, Path } from "react-hook-form";
import MedspaTermsModal from "@/components/serviceFlow/forms/intakeForms/medspaTermsModal";
import { ClientDetailsInput } from "@/types/bookingTypes";

type AgreementCheckboxProps<Schema> = {
  control: Control<Schema>;
  errors: FieldErrors<ClientDetailsInput>;
  medspaId: string;
  name: Path<Schema>;
};

function AgreementCheckbox<S>({
  control,
  errors,
  medspaId,
  name,
}: AgreementCheckboxProps<S>) {
  const [modalOpen, setModalOpen] = React.useState(false);

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <>
            <FormControlLabel
              control={
                <Checkbox
                  {...field}
                  checked={field.value as boolean}
                  sx={{
                    color: errors.ageConsent ? "error.main" : "",
                    alignSelf: "flex-start",
                  }}
                />
              }
              label={
                <Typography
                  variant="labelDefault"
                  sx={{
                    color: "secondary.main",
                    mt: 1,
                  }}
                >
                  I confirm I am over the age of 18, or I am the legal guardian
                  booking on behalf of the named individual. If I am the legal
                  guardian, I attest that the information is correct. I consent
                  to the{" "}
                  <Link
                    style={{ pointerEvents: "auto" }}
                    component="span"
                    onClick={(e) => {
                      e.preventDefault();
                      setModalOpen(true);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        setModalOpen(true);
                      }
                    }}
                    role="button"
                    tabIndex={0}
                  >
                    Privacy and Telehealth terms.
                  </Link>
                </Typography>
              }
            />
            <FormHelperText error={!!errors.ageConsent}>
              {errors.ageConsent?.message ?? ""}
            </FormHelperText>
          </>
        )}
      />
      <MedspaTermsModal
        medspaId={medspaId}
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </>
  );
}

export default AgreementCheckbox;
